var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-input',{attrs:{"name":_vm.config.field,"size":"small","allowClear":""},on:{"pressEnter":function($event){return _vm.$emit('apply-filters')}},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }